















import Vue from 'vue';
import { mapActionsDvm } from '@/main/pages';
import { genVuexComputeds } from '@/main/pages/editFactory';

import { store } from '../../store/edit';

export default Vue.extend({
	name: 'OzakazkaSkupinaProfilSelect',
	props: {
		storeUri: { type: String, default: null },
	},
	computed: {
		...genVuexComputeds(store),
	},
	methods: {
		...mapActionsDvm(store.actions),
	},
});
